import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, of, switchMap, take } from 'rxjs';
import { ContentListService } from './content-list.service';
import Fuse from 'fuse.js';
import { SearchResult, SearchResults } from 'src/app/shared/interfaces/search-results.interface';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private contentService = inject(ContentListService);
  searchTerm$ = new BehaviorSubject('');

  searchResults$: Observable<SearchResults | null> = this.searchTerm$.pipe(
    switchMap(term => this.search(term))
  );

  fuseSearch: Fuse<SearchResult>;

  constructor() {
    const contentList$ = this.contentService.getContentList().pipe(
      map(result => {
        if (!result) {
          return [];
        }
        
        const ranges = result.content.map(range => {
          return {
            id: `${range.id}`,
            title: range.name,
            url: `${range.id}`,
            desc: '',
            img: '',
            isRange: true
          } as SearchResult
        });
        const machines = result.content.flatMap(range => {
          return range.children.map(machine => {
            return {
              id: `${machine.id}`,
              title: machine.title,
              desc: machine.sub_heading,
              url: `${machine.id}`,
              img: `${machine.thumbnail.asset_id}`,
              isRange: false,
              rangeId: `${range.id}`,
              rangeTitle: range.name
            } as SearchResult;
          })
        })
        return ranges.concat(machines);
      })
    );

    contentList$.pipe(
      take(1),
      map(result => {
        this.fuseSearch = new Fuse(result, {
          keys: ['title'],
          useExtendedSearch: true
        })
      })
    ).subscribe();
  }


  private search(term: string): Observable<SearchResults | null> {
    if (!term) {
      return of(null);
    }

    const results = this.fuseSearch.search(`'${term}`);

    return of({
      results: {
        ranges: results.filter(result => result.item.isRange).map(result => result.item),
        machines: results.filter(result => !result.item.isRange).map(result => result.item)
      }
    } as SearchResults);
  }
}
